function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { TextInput } from '../..';
/**
 * Gets the locale decimal separator character from the browser.
 *
 * @returns {string} The local decimal separator.
 */

function getLocaleSeparator() {
  return 1.1.toLocaleString().substring(1, 2);
}

function escapeSeparator(separator) {
  return separator === '.' ? '\\.' : separator;
}

var NumberInput = /*#__PURE__*/function (_PureComponent) {
  _inherits(NumberInput, _PureComponent);

  var _super = _createSuper(NumberInput);

  function NumberInput() {
    var _this;

    _classCallCheck(this, NumberInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      // Raw value: This is the string used to control the inner input.
      rawValue: null,
      // Parsed value: This is the parsed number value from the raw value.
      parsedValue: null,
      // Whether the component has focus. This value is used to allow keyboard increase and decrease
      // of the value.
      hasFocus: false
    });

    _defineProperty(_assertThisInitialized(_this), "isNumber", function (rawValue) {
      var separator = _this.props.separator;
      return new RegExp("^-?\\d+(".concat(escapeSeparator(separator), "\\d+)?$")).test(rawValue);
    });

    _defineProperty(_assertThisInitialized(_this), "updateValue", function (newParsedValue) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          min = _this$props.min,
          max = _this$props.max; // Checks bounds.
      // Have to use value != null since 0 is equivalent to null boolean wise.

      var parsedValue = newParsedValue;

      if (min != null && newParsedValue < min) {
        parsedValue = min;
      } else if (max != null && newParsedValue > max) {
        parsedValue = max;
      }

      _this.setState({
        parsedValue: parsedValue
      }, function () {
        onChange(parsedValue);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "formatValue", function () {
      var _this$state = _this.state,
          rawValue = _this$state.rawValue,
          parsedValue = _this$state.parsedValue;
      var _this$props2 = _this.props,
          decimals = _this$props2.decimals,
          separator = _this$props2.separator;
      return rawValue ? (parsedValue !== null ? parsedValue.toFixed(decimals) : rawValue).replace('.', separator) : rawValue;
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (rawValue) {
      var separator = _this.props.separator;
      var parsedValue = _this.isNumber(rawValue) ? parseFloat(rawValue.replace(separator, '.')) : null;

      _this.setState({
        rawValue: rawValue
      }, function () {
        _this.updateValue(parsedValue);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function () {
      var _this$props3 = _this.props,
          onFocus = _this$props3.onFocus,
          _onFocus = _this$props3._onFocus;

      _this.setState({
        hasFocus: true
      }, function () {
        onFocus();

        _onFocus();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function () {
      var _this$props4 = _this.props,
          onBlur = _this$props4.onBlur,
          _onBlur = _this$props4._onBlur;

      _this.setState({
        hasFocus: false
      }, function () {
        onBlur();

        _onBlur();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (event) {
      var _this$state2 = _this.state,
          hasFocus = _this$state2.hasFocus,
          parsedValue = _this$state2.parsedValue;
      var step = _this.props.step; // Checks if the input has focus since we connect the event listener to the window.

      if (hasFocus) {
        if (event.code === 'ArrowUp') {
          _this.updateValue(parsedValue + step);
        }

        if (event.code === 'ArrowDown') {
          _this.updateValue(parsedValue - step);
        }
      }
    });

    return _this;
  }

  _createClass(NumberInput, [{
    key: "componentDidMount",
    value:
    /**
     * Handles mounting step in component's lifecycle.
     */
    function componentDidMount() {
      var _this2 = this;

      var value = this.props.value;

      if (value) {
        this.setState({
          rawValue: "".concat(value)
        }, function () {
          _this2.updateValue(value);
        });
      }

      document.addEventListener('keydown', this.handleKeyDown);
    }
    /**
     * Handles updated step in component's lifecycle.
     *
     * @param {Object} prevProps - The component's previous props.
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref) {
      var prevValue = _ref.value;
      var currValue = this.props.value;

      if (currValue != prevValue) {
        this.updateValue(currValue);
      }
    }
    /**
     * Handles unmounting step in component's lifecycle.
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.handleKeyDown);
    }
    /**
     * Checks whether the given value is a string of a number or not.
     *
     * @param {string} rawValue - The string to check.
     *
     * @return {boolean} true if the given string is a number, false otherwise.
     */

  }, {
    key: "render",
    value:
    /**
     * Renders the component.
     *
     * @returns {jsx}
     */
    function render() {
      var rawValue = this.state.rawValue;

      var _this$props5 = this.props,
          width = _this$props5.width,
          fluid = _this$props5.fluid,
          id = _this$props5.id,
          tabIndex = _this$props5.tabIndex,
          disabled = _this$props5.disabled,
          label = _this$props5.label,
          labelPosition = _this$props5.labelPosition,
          validate = _this$props5.validate,
          info = _this$props5.info,
          success = _this$props5.success,
          warning = _this$props5.warning,
          error = _this$props5.error,
          placeholder = _this$props5.placeholder,
          rest = _objectWithoutProperties(_this$props5, ["width", "fluid", "id", "tabIndex", "disabled", "label", "labelPosition", "validate", "info", "success", "warning", "error", "placeholder"]);

      var hasValidValue = this.isNumber(rawValue);
      return /*#__PURE__*/React.createElement(TextInput, _extends({}, rest, {
        placeholder: placeholder,
        width: width,
        fluid: fluid,
        id: id,
        tabIndex: tabIndex,
        disabled: disabled,
        value: this.formatValue(),
        label: label,
        labelPosition: labelPosition,
        info: info,
        success: success || validate && hasValidValue,
        warning: warning,
        error: error || validate && !hasValidValue,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
      }));
    }
  }]);

  return NumberInput;
}(PureComponent);

var bool = PropTypes.bool,
    func = PropTypes.func,
    number = PropTypes.number,
    oneOf = PropTypes.oneOf,
    shape = PropTypes.shape,
    string = PropTypes.string;
/** Display name. */

NumberInput.displayName = 'NumberInput';
/** Prop types validation. */

NumberInput.propTypes = {
  /**
   * Numbers of decimals the input value has to display.
   */
  decimals: number,

  /**
   *  Whether the input is disabled or not
   */
  disabled: bool,

  /**
   * whether the input has error status
   */
  error: bool,

  /**
   * Whether the input takes all available space or not
   */
  fluid: bool,

  /**
   * The ID of the input
   */
  id: string,

  /**
   * Whether the input has info status
   */
  info: bool,

  /**
   * Defines the label with either `icon` with the name of the icon to display, or
   * `text` with the text to display
   */
  label: shape({
    icon: string,
    text: string
  }),

  /**
   * Position of label (`left` or `right`)
   */
  labelPosition: oneOf(['left', 'right']),

  /**
   * Maximum value of the number value
   */
  max: number,

  /**
   * Mimimum value of the number value
   */
  min: number,

  /**
   * Handler when input loses focus
   */
  onBlur: func,

  /**
   * Handler of input value change
   */
  onChange: func,

  /**
   * Handler when input gains focus
   */
  onFocus: func,

  /**
   * Placeholder text
   */
  placeholder: string,

  /**
   * What will separate the integer part from the decimals. Default value depends from user browser
   */
  separator: string,

  /**
   * Value of increment or decrement when using arrow keys
   */
  step: number,

  /**
   * Whether the input has success status
   */
  success: bool,

  /**
   * Index of the input in a parent form
   */
  tabIndex: string,

  /**
   * Whether the input has to be checked for validation or not
   */
  validate: bool,

  /**
   * The value of the input
   */
  value: number,

  /**
   * Whether the input has warning status
   */
  warning: bool,

  /**
   * The width of the input
   */
  width: string,

  /**
   * Internal handler when input loses focus
   */
  _onBlur: func,

  /**
   * Internal handler when input gains focus
   */
  _onFocus: func
};
/** Default props. */

NumberInput.defaultProps = {
  decimals: 0,
  disabled: false,
  error: false,
  fluid: false,
  id: '',
  info: false,
  label: null,
  labelPosition: 'left',
  max: null,
  min: null,
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  placeholder: '0',
  separator: getLocaleSeparator(),
  step: 1,
  success: false,
  tabIndex: '0',
  validate: false,
  value: null,
  warning: false,
  width: '25rem',
  _onFocus: function _onFocus() {},
  _onBlur: function _onBlur() {}
};
export default NumberInput;